import { render, staticRenderFns } from "./ProfilesForm.vue?vue&type=template&id=ec3d8018"
import script from "./ProfilesForm.vue?vue&type=script&lang=js"
export * from "./ProfilesForm.vue?vue&type=script&lang=js"
import style0 from "./ProfilesForm.vue?vue&type=style&index=0&id=ec3d8018&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports